module.exports = __webpack_public_path__ + "img/manosque_dark_grey.2133de18.jpeg";